const knowledgeBase = {
  greetings: {
    keywords: ["hello", "hi", "hey", "hy", "hye", "hii", "helo", "yo", "greeting", "good morning", "good afternoon"],
    response: "Hello! I'm the Observant Security Assistant. How can I help you today? I can provide details on our specialised security services, our expertise in Solar Panel protection, or help you get a quote."
  },
  status: {
    keywords: ["how are you", "hows it going", "how r u", "how are u", "u okay", "everything good"],
    response: "I'm doing great, thank you for asking! I'm ready to help you secure your site. What can I tell you about our security solutions today?"
  },
  identity: {
    keywords: ["who are you", "who is observant", "about the company", "tell me about", "background", "experience", "how long"],
    response: "Observant Security is a professional, service-driven security firm and leading specialists in protecting critical assets across the Midlands. Based in Birmingham (Castle Vale), we specialise in high-stakes security for solar panels, construction sites, building sites, retail premises, door supervisor services, and corporate environments using SIA-licensed elite personnel."
  },
  location: {
    keywords: ["location", "where are you", "base", "areas", "birmingham", "coventry", "midlands"],
    response: "We are headquartered in Birmingham (Unit A9, Park Lane, Castle Vale, B35 6LJ), primarily serving the West Midlands and the surrounding Midlands region. We provide comprehensive security solutions across the Midlands for projects of all sizes."
  },
  solar: {
    keywords: ["solar", "farm", "renewable", "panels", "energy", "copper", "theft", "cabling"],
    response: "We are Midlands specialists in Solar Panel Security. We protect your assets with:\n• Advanced thermal imaging (1km+ detection)\n• Smart perimeter vibration sensors\n• Rapid response teams in all-terrain vehicles\n• 100% asset protection history.\nWould you like to speak to a solar security specialist?"
  },
  construction: {
    keywords: ["construction", "site", "building", "developer", "machinery", "plant", "theft"],
    response: "We secure construction sites and building sites throughout the Midlands. Our door supervisors and security guards manage strict access control and perimeter patrols to prevent the theft of high-value plant machinery and raw materials, keeping your project on schedule."
  },
  retail: {
    keywords: ["retail", "shop", "store", "loss prevention", "shoplifting", "shopping"],
    response: "Our retail security teams provide professional loss prevention and in-store security services across the Midlands. Our officers are trained in conflict de-escalation, search procedures, and customer service to protect your business while maintaining a welcoming environment."
  },
  doorSupervisor: {
    keywords: ["door supervisor", "door", "bouncer", "pub", "club", "licensed", "venue", "premises"],
    response: "We provide fully SIA-licensed door supervisors for licensed premises throughout the Midlands. All our door supervisors hold current SIA Door Supervisor licences and are trained in conflict management, first aid, and licensing law compliance."
  },
  corporate: {
    keywords: ["corporate", "office", "business", "concierge", "reception", "hospitality"],
    response: "Our corporate security blends elite protection with professional hospitality. Our officers are hospitality-trained to manage front-of-house concierge while maintaining rigorous security protocols for your staff and sensitive data."
  },
  warehouses: {
    keywords: ["warehouse", "logistics", "distribution", "hub", "inventory", "gatehouse", "hgv"],
    response: "For warehouses, we focus on gatehouse integrity and inventory transparency. We audit HGV manifests, check vehicle seals, and conduct internal patrols to stop shrinkage and secure your supply chain."
  },
  vetted: {
    keywords: ["sia", "licensed", "badge", "vetted", "training", "guards", "officers", "personnel"],
    response: "Trust is paramount. Every single Observant Security officer is 100% SIA licensed, fully vetted, and trained to the highest industry standards. We don't just provide guards; we provide professional safety specialists."
  },
  contact: {
    keywords: ["contact", "call", "email", "quote", "price", "cost", "hire", "get a quote", "phone"],
    response: "You can reach us at +44 7446 084868. Alternatively, click the 'GET A QUOTE' button at the top of our website to receive a tailored security proposal for your site."
  },
  brochure: {
    keywords: ["brochure", "profile", "download", "pdf", "info", "details"],
    response: "You can download our full company brochure on our dedicated Brochure page. It contains detailed case studies, service breakdowns, and our technical standards."
  },
  thanks: {
    keywords: ["thanks", "thank you", "great", "awesome", "perfect", "bye", "goodbye"],
    response: "You're very welcome! Feel free to reach out if you have any more questions about your security needs. Stay safe!"
  }
};

/**
 * Enhanced response logic with multi-keyword matching and fallbacks.
 */
export const getBotResponse = (input) => {
  if (!input) return "I'm sorry, I didn't catch that. How can I help you with your security needs?";
  
  const cleanInput = input.toLowerCase().replace(/[?.,!]/g, "").trim();
  
  // Try to find the best matching category
  for (const category in knowledgeBase) {
    if (knowledgeBase[category].keywords.some(keyword => cleanInput.includes(keyword))) {
      return knowledgeBase[category].response;
    }
  }
  
  // Smart fallback
  return "That's an important question. While I can answer most things about our services, for specific site requirements, I recommend speaking directly with one of our security specialists. You can call us at +44 7446 084868 or use the 'GET A QUOTE' form.";
};
